import React from 'react';
import { Form } from 'react-bootstrap';
import { useGetChoices } from '../properties/useGetChoices';
import { IQuestion } from '../properties/assessment';

interface MultiSelectQuestionProps {
  question: IQuestion;
  value: string[];
  onChange: (value: string[]) => void;
  onBlur: () => void;
}

const MultiSelectQuestion: React.FC<MultiSelectQuestionProps> = ({ question, value, onChange, onBlur }) => {
  const { choices } = useGetChoices(question.questionId || '');

  const handleCheckboxChange = (optionValue: string) => {
    const newValue = value.includes(optionValue)
      ? value.filter(v => v !== optionValue)
      : [...value, optionValue];
    onChange(newValue);
  };

  return (

    <div>
      {/* <label className="form-label">Question: {question.questionNumber} <span dangerouslySetInnerHTML={{ __html: question.questionDescription }}></span></label> */}
      <div>
        {choices.map((option, index: number) => (
          <Form.Group key={index} className="mb-3">
            <Form.Check
              key={index}
              type="checkbox"
              className='mb-1'
              id={`${question.questionId}-${option.name}`}
              label={option.name}  // Ensure a label is always shown
              checked={value.includes(option.choiceid)}
              onChange={() => handleCheckboxChange(option.choiceid)}
              onBlur={onBlur}
            />
          </Form.Group>
        ))}
      </div>
    </div>
  );
};

export default MultiSelectQuestion;
